<template>
<div class="cert" v-loading="pageLoading">
  <van-nav-bar
      ref="nav"
      :border="false"
      @click-left="back"
      placeholder
      :fixed="true"
      title="证书查询"
    >
      <template #left>
        <van-icon size="20px" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
  <div class="main" id="main">
    <div>
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E5%8F%B7%402x.png"/>
      <span></span>
      <input v-model="form.cert_no" type="text" placeholder="请输入证书编码"/>
    </div>
    <div>
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E8%BA%AB%E4%BB%BD%E8%AF%81%402x.png"/>
      <span></span>
      <input v-model="form.cid" type="idcard" placeholder="请输入身份证号码"/>
    </div>
    <div>
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E5%BD%A2%E7%8A%B6%402x.png"/>
      <span></span>
      <input v-model="form.name" placeholder="请输入姓名"/>
    </div>
    <p>注：以上三项输入任意两项即可查询。</p>
    <button @click="submit" :class="{gray:flag<2}">开始查询</button>
  </div>
</div>
</template>

<script>
export default {
  name: "cert",
  data() {
    return {
      pageLoading: false,
      time:0,
      timer:null,
      form: {
        name:'',
        cid:'',
        cert_no:'',
      },
    }
  },
  mounted() {
    let userData = JSON.parse(localStorage.getItem('userdata'))
    this.form.name = userData.name || userData.nickname
  },
  destroyed() {},
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
    flag(){
        let flag = 0
        for(let v of Object.values(this.form)){
          if(v) flag++
        }
        return flag
    }
  },
  methods: {
    async submit(){
      if(this.flag<2) return
      this.$router.push('./certList?type=certForm&form='+JSON.stringify(this.form))
      
    },
    async getCode(){
      if(this.$until.checkPhone(this.form.mobile)!='ok'){
        return this.$toast(this.$until.checkPhone(this.form.mobile))
      }
      if(this.time)  return
      this.time = 60
      this.timer = setInterval(()=>{
        if(this.time){
          this.time--
        }else{
          clearInterval(this.timer)
        }
      },1000)
      await this.$request.certSms(this.form.mobile)
    },
    back() {
      this.$router.go(-1);
    },

  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    console.log(to)
    next()
  },
  beforeDestroy(){
    clearInterval(this.timer)
  }

};
</script>

<style lang="scss" scoped>
.cert {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F7F8FA;
  align-items: center;
  padding: 50px 0;
    .main{
      overflow-y: auto;
      flex: 1;
      padding: 0 52px;
      button{
        border: 0;
        padding: 0;
        background: none;
      }
      >button{
        width: 100%;
        height: 105px;
        line-height: 105px;
        background: #0190f8;
        border-radius: 52px;
        color: #fff;
        font-size: 34px;
        margin-top: 80px;
      }
      button.gray{
        background: #e2e2e2;
        color: #999;
      }
      >p{
        font-size: 26px;
        color: #666;
        margin-top: -20px;
      }
      input{
        border: 0;
      }
      >div{
        display: flex;
        width: 100%;
        height: 105px;
        background: #FFFFFF;
        border-radius: 52px;
        align-items: center;
        padding-left: 54px;
        margin-bottom: 61px;
        padding-right: 30px;
        img{
          width: 42px;
          height: 42px;
          margin-right: 20px;
        }
        span{
          width: 2px;
          height: 37px;
          background-color: #BEBEBE;
        }
        input{
          flex:1;
          margin-left: 30px;
          font-size: 33px;
          color: #000000;
          width: 100%;
        }
        button{
          flex-shrink: 0;
          text-align: center;
          margin-left: 30px;
          font-size: 28px;
          color: #A40001;
        }
        .gray{
          color: #333;
        }
      }
    }
  }

</style>

